module.exports = __webpack_public_path__ + "static/img/GemsofOlympus-zh.d841b54c.png";